'use client';

import type { FC } from 'react';
import { ItemListItemSkeleton } from '../../components/ItemListItemSkeleton';

export const ShopSkeleton: FC = () => (
  <div className="grid grid-cols-[repeat(auto-fill,minmax(min(100%,160px),1fr))] items-start gap-1 pt-2">
    {Array.from({ length: 16 }).map((_, i) => (
      <ItemListItemSkeleton key={i} />
    ))}
  </div>
);
